import { getSystemInfoSync } from '@max/meituan-uni-system';
export const { statusBarHeight, screenHeight, screenWidth, appId = '', platform } = getSystemInfoSync() || {};
export const isAndroid = platform === 'android' || platform === 'Android';
export const isIos = platform === 'ios' || platform === 'iOS';
export function compareVersion(v1, v2) {
    const arr1 = v1.split('.');
    const arr2 = v2.split('.');
    const len = Math.max(arr1.length, arr2.length);
    while (arr1.length < len) {
        arr1.push('0');
    }
    while (arr2.length < len) {
        arr2.push('0');
    }
    for (let i = 0; i < len; i++) {
        const num1 = parseInt(arr1[i]);
        const num2 = parseInt(arr2[i]);
        if (num1 > num2) {
            return 1;
        }
        else if (num1 < num2) {
            return 0;
        }
    }
    return 1;
}
